// TimeFrameSelect.js
import { Text, useMainContext } from '../../../../modules/Dashboard'
import useTimeFrame, { getFrameLabel, TIME_FRAMES } from './core'
import { ReactComponent as TimeVector } from '../../assets/icons/TimeVector.svg';

const TimeFrameSelect = ({ className = '' }) => {
    const { timeFrame, handleSelect, shouldRenderTimeFrame } = useTimeFrame()
    const { main: { lang } } = useMainContext()

    if (!shouldRenderTimeFrame()) return null

    return (
        <>
            <div className='flex items-center gap-2'>
                <TimeVector width={40} height={40} />
                <Text tid="choose-timeframe" className='text-xl' />
            </div>
            <div className={`flex flex-col gap-4 w-full ${className}`}>

                <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3">
                    {TIME_FRAMES.map(item => (
                        <button
                            key={item.frame}
                            onClick={() => {
                                handleSelect(item.frame)
                            }}
                            className={`
                                flex items-center justify-center gap-2 p-3 md:p-5 rounded-xl border dark:border-[#AD46FF4D] transition 
                                ${item.frame === timeFrame
                                    ? "bg-gradient-to-bl from-[#9810FA4D] to-[#FF69004D] shadow-lg shadow-[#AD46FF33]"
                                    : "dark:bg-secondaryBgDark"
                                }
                            `}
                        >
                            <span className="font-medium">{item.frame}</span>
                        </button>
                    ))}
                </div>
            </div>
        </>
    )
}

export default TimeFrameSelect